module.exports = __webpack_public_path__ + "img/image-default.cdc7bab5.jpg";